// extracted by mini-css-extract-plugin
export default {"overlay":"DeRegisterSuccess_overlay__pA1Qi","dialog":"DeRegisterSuccess_dialog__by7QB","title":"DeRegisterSuccess_title__gk20E","closeButton":"DeRegisterSuccess_closeButton__oDo9f"};